import { createFileRoute } from '@tanstack/react-router';

import { RequestPage } from '../../../../features/estimates/ui/request-page.tsx';
import { requirePermissionRoute } from '../../../../lib/permissions.ts';

export const Route = createFileRoute('/_app/estimates/requests/$id')({
  beforeLoad: requirePermissionRoute('sales.use'),
  component: RequestRoute,
});

/** «Оценить этап» исполнителя: `/estimates/requests/<id>` — ссылка из уведомления. */
function RequestRoute() {
  const { id } = Route.useParams();
  return <RequestPage id={id} />;
}
